import React from 'react';
import styled from 'styled-components';
import { isKiosk } from 'utils/platform';
import { e2e } from 'utils/queryUtils';
import { useAppDispatch } from 'ducks/hooks';
import { getShowBannerMessage, setShowBannerMessage } from 'ducks/layout';
import { useServiceSettings } from 'contexts/serviceSettings';
import SkapaInlineMessage, { InlineMessageVariantEnum } from 'ui/InlineMessage/SkapaInlineMessage';
import InformationCircle from '@ingka/ssr-icon/paths/information-circle';
import WarningTriangle from '@ingka/ssr-icon/paths/warning-triangle';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

const Wrapper = styled.div`
  padding: 1.25rem 0;
  &[data-visible='false'] {
    display: none;
  }

  @media screen and (max-width: 800px) {
    padding-right: 0;
  }
`;

const BannerMessage = () => {
  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();
  const {
    range,
    dexfSettings: {
      general: { bannerMessageType, bannerMessageTypeKiosk }
    }
  } = useServiceSettings();
  const showBannerMessage = useSelector(getShowBannerMessage);

  const title = isKiosk()
    ? 'storageone.' + range + 'PlannerBannerMessageTitleKiosk'
    : 'storageone.' + range + 'PlannerBannerMessageTitle';

  const body = isKiosk()
    ? 'storageone.' + range + 'PlannerBannerMessageBodyKiosk'
    : 'storageone.' + range + 'PlannerBannerMessageBody';

  const type = isKiosk() ? bannerMessageTypeKiosk : bannerMessageType;

  const messageVariant =
    type === 'caution' ? InlineMessageVariantEnum.CAUTIONARY : InlineMessageVariantEnum.INFORMATIVE;

  // Never show banner message in E2E-tests
  if (e2e() || !showBannerMessage) return <></>;

  return (
    <Wrapper data-visible={showBannerMessage}>
      <SkapaInlineMessage
        title={formatMessage({ id: title })}
        body={formatMessage({ id: body })}
        variant={messageVariant}
        ssrIcon={messageVariant === 'cautionary' ? WarningTriangle : InformationCircle}
        onClose={() => {
          dispatch(setShowBannerMessage(false));
        }}
        dismissable
      />
    </Wrapper>
  );
};

export default BannerMessage;
